import React from 'react';
import Container from './styles';
import Contact from '../home/sections/Contact';
import Beta from './section/Beta';
import Prices from './section/Prices';

const Inscriptions = () => (
	<Container>
		<Beta />
		<Prices />
		<Contact />
	</Container>
);

export default Inscriptions;
